let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName] && subscribers[eventName].length) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        const result = callback(data);
        return result instanceof Promise ? result : Promise.resolve(result);
      } catch (e) {
        console.warn('pubsub subscriber error:', eventName, e);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  }
  return Promise.resolve();
}
